import { render, staticRenderFns } from "./UncommitOutbound.vue?vue&type=template&id=6b711dba&"
import script from "./UncommitOutbound.vue?vue&type=script&lang=js&"
export * from "./UncommitOutbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports